import { unitFor, testIdFor } from "@/lib/serviceCatalog";

export const BasePrices = ({ services, prices, onPrices }) => (
  <div className="divide-y divide-border" data-testid="base-prices">
    {services.length === 0 && <p className="py-3 text-sm text-muted-foreground">Select services above to set prices.</p>}
    {services.map((s) => (
      <div key={s} className="flex items-center gap-3 py-3">
        <div className="min-w-0 flex-1">
          <p className="truncate font-semibold text-foreground">{s}</p>
          <p className="text-xs text-muted-foreground">{unitFor(s)}</p>
        </div>
        <div className="relative w-28 shrink-0">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">$</span>
          <input type="number" inputMode="decimal" min="0" step="0.01" placeholder="—" value={prices[s] ?? ""} data-testid={`base-price-${testIdFor(s)}`}
            onChange={(e) => onPrices({ ...prices, [s]: e.target.value === "" ? null : Number(e.target.value) })}
            className="h-12 w-full rounded-xl border-2 border-border bg-card pl-7 pr-2 text-right text-base font-semibold outline-none focus:border-[color:var(--brand)]" />
        </div>
      </div>
    ))}
  </div>
);
